import React, { useEffect, useRef, useState } from "react";
import Images from "../../assets/Image";
import KnowAsServiceHeader from "../KnowAsServiceHeader";
import ContactUsFooter from "../ContactUsFooter";

const SupportComp = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [showIcons, setShowIcons] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setShowIcons(true);
    } else {
      setShowIcons(false);
    }
  }, [isOpen]);

  const [inView, setInView] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setInView(true); // Set the state to true when section is in view
          }
        });
      },
      {
        threshold: 0.5, // Trigger when 50% of the section is visible
      }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    // Cleanup observer on component unmount
    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <>
      <KnowAsServiceHeader content="SERVICES & SUPPORT" />
      <div className="support_heading_content__block">
        <div className="support_sub_block">
          <div className="support_left_content_block">
            <h6 className="support_welcome_content">welcome to</h6>
            <h6 className="support_content_para_heading">USP</h6>
            <p className="support_content_para">
              The journey of a thousand miles begins with a single step… Mr.
              Joseph established USP in the year 2005, with the objective of
              introducing technology‐driven solutions in the packaging industry.
              Much like the packaging industry that has evolved with newer
              printers that offer better quality and cost‐effectiveness, USP has
              grown steadily over the years to become a market leader today
            </p>
          </div>
          <div className="support_right_image_block">
            <div className="support-image-block">
              <img
                src={Images?.supportIcon}
                alt="no-image"
                style={{ width: "100%", height: "100%", objectFit: "contain" }}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="support_content__block">
        <div className="support_content_section">
          <h5 className="support_content_para_sub_heading my-3">
            Services on Offer
          </h5>
          <p className="support_sub_content_para">
            Industrial printers are getting better and more user‐friendly by the
            day, thanks to technological advancements that herald exciting
            changes, resulting in enhanced overall functioning of
            these printers. Our team of professionals is ever standing by, to
            help you understand new features, take you through printer setup
            and, to promptly provide support in addressing any of your
            queries regarding these printers and their functions.
          </p>
          <h5 className="support_content_para_sub_heading my-3">
            Onsite Service
          </h5>
          <p className="support_sub_content_para">
            Our field technicians ‐ well‐trained and certified professionals
            with in‐depth industry exposure - visit your site to help you tackle
            and solve technical problems related to the printer. The
            result? Least impact on the productivity of the printer by way of
            quick turnaround, with virtually zero downtime.
          </p>
          <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
            <li className="support_sub_content_para">
              Timely visits ensure smooth running of production lines and zero
              loss in productivity.
            </li>
            <li className="support_sub_content_para">
              All technicians are certified professionals with in‐depth
              knowledge of the machines.
            </li>
            <li className="support_sub_content_para">
              Our team aims at providing exceptional customer service, every
              single time, ensuring quick turnaround that results in customer
              delight.
            </li>
          </ul>
          <h5 className="support_content_para_sub_heading my-3">
            Technical Support
          </h5>
          <p className="support_sub_content_para">
            At times, you might just have a simple doubt regarding your printer…
            something that does not require a technician visit. For such
            instances, our technical support team ‐ available round the clock ‐
            provides you with effective assistance over phone, for your
            printers. Be it a small query on a feature or, detailed information
            on the functions, this team handles them all with professional ease.
          </p>
          <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
            <li className="support_sub_content_para">
              24x7 support for all products.
            </li>
            <li className="support_sub_content_para">
              Trained professionals,who can expertly handle such situations,
              will be attending to your calls. Their complete understanding of
              the problem through precise trouble‐shooting results in the right
              solutions always to your advantage
            </li>
          </ul>
          <h5 className="support_content_para_sub_heading my-3">
            Technical training
          </h5>
          <p className="support_sub_content_para">
            Having purchased the printer of your choice, it is imperative that
            your team be adequately trained in the ways and methods of the
            printer’s functional procedures. And, to fulfil this requisite,
            we have a team of professionals who will undertake to train your
            team in order to understand the equipment’s functional parameters
            and, the procedures to operate it. Furthermore, this training will
            enable you to deploy the necessary software programmes/applications
            that run in tandem with the printer so that you, as our valuable
            customer, may derive maximum benefit from our product and support.
            At the same time, your employees on the production line evolve in
            knowledge and understanding of our products and their
            functionalities to be better equipped in their effort to move
            towards zero defect
          </p>
          <h5 className="support_content_para_sub_heading my-3">
            HOW YOU STAND TO BENEFIT
          </h5>
          <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
            <li className="support_sub_content_para">
              All technical trainings are conducted by certified professional
              trainers.
            </li>
            <li className="support_sub_content_para">
              Flexible timings for training to suit your production schedule or
              the availability of your employees.
            </li>
            <li className="support_sub_content_para">
              The use of software programs and applications will also be covered
              as a part of the training.
            </li>
          </ul>
          <h5 className="support_content_para_sub_heading my-3">
            Product Sampling
          </h5>
          <p className="support_sub_content_para">
            actually buy the product. We provide Product Sampling services to
            all industries to ensure that you get exactly what you want. You can
            do a check on factors such as quality, clarity, and longevity of the
            prints on the Products. You can request Product Sampling by calling
            us on <u>+91 97909 34910</u> or emailing us at{" "}
            <u>enquiries@usppkg.com.</u>
          </p>
        </div>
      </div>

      <div className="support_heading_content__block">
        <div
          className={`support_bottom_sub_block ${inView ? "in-view" : ""}`}
          ref={sectionRef}
        >
          <div
            className={`support_bottom_left_content_block ${inView ? "in-view" : ""
              }`}
          >
            <h6 className="support_content_para_sub_heading">
              Annual Maintenance
            </h6>
            <p className="support_content_para">
              This maintenance ensures that the printers will be thoroughly
              checked, all parts inspected and serviced by a team or an
              individual who will identify potential problems, to nip them right
              away. the result? Increased uptime, zero defect and, guaranteed
              satisfaction always!
            </p>
            <br />
            <p className="support_content_para">
              You can schedule your annual maintenance according to your
              convenience by calling us or by emailing us. We will promptly
              respond to your request and provide you with necessary details
              required when the technician arrives at your place.
            </p>
            <br />
            <p className="support_content_para">
              Again, reminding ourselves and ensuring that
            </p>
            <h6 className="support_bottom_info">
              WE PROMISE WHAT WE DELIVER and DELIVER WHAT WE PROMISE!
            </h6>
          </div>
          <div
            className={`support_bottom_right_image_block ${inView ? "in-view" : ""
              }`}
            style={{ background: "#26282A", height: "68vh" }}
          >
            <div className="support-image-block">
              <img
                src={Images?.goldproIcon}
                alt="no-image"
                style={{ width: "100%", height: "100%" }}
              />
            </div>
          </div>
        </div>
      </div>
      <ContactUsFooter />
      {/* <div>
        {!isOpen && (
          <>
            <button className="blog_content_bottom_btn">
              tap to connect here
            </button>
            <div
              className="blog_bottom_share"
              onClick={() => {
                setIsOpen(!isOpen);
              }}
            >
              +
            </div>
          </>
        )}

        {isOpen && (
          <>
            <div
              className={`blog_share_icons_block ${showIcons ? "show" : ""}`}
            >
              <img
                src={Images?.whatsappIcon}
                alt="instagram"
                className={`blog_share_icones_sizes ${
                  showIcons ? "showIcon" : ""
                }`}
              />
              <img
                src={Images?.instagramIcon}
                alt="instagram"
                className={`blog_share_icones_sizes ${
                  showIcons ? "showIcon" : ""
                }`}
              />
              <img
                src={Images?.facebookIcon}
                alt="facebook"
                className={`blog_share_icones_sizes ${
                  showIcons ? "showIcon" : ""
                }`}
              />
              <img
                src={Images?.youtueIcon}
                alt="youtube"
                className={`blog_share_icones_sizes ${
                  showIcons ? "showIcon" : ""
                }`}
              />
            </div>
            <div
              className="blog_bottom_share"
              onClick={() => {
                setIsOpen(!isOpen);
                setShowIcons(false);
              }}
            >
              x
            </div>
          </>
        )}
      </div> */}
    </>
  );
};

export default SupportComp;
